export default __webpack_public_path__ + "motion_settings.15d2d2f1.png";